import { canGetOrganizationSettingsPage } from "@/route-authorization";

export const organization = {
  routes: [
    {
      // TKP-150 (TKP-149 dashboard kararıyla): organizasyon paneli panosu her organizasyon üyesine açık — kartlar kullanıcının
      // kapsamına göre; yalnız Ayarlar ve Kişiler Sistem Yöneticisi'nde (TKP-99 / matris K)
      path: "/organization",
      component: () => import("../dashboard"),
    },

    {
      path: "/organization/members",
      component: () => import("../organization-members-view"),
      meta: { rules: [canGetOrganizationSettingsPage] },
    },
    {
      path: "/organization/settings",
      component: () => import("../organization-settings"),
      meta: { rules: [canGetOrganizationSettingsPage] },
    },
  ],
};
